import React from 'react';

class Heading extends React.Component {
    render() {
        return <div className="row">
            <div id="heading-left" className="col-7">
                <img className="logo-color-gjeldsregisteret" src={process.env.PUBLIC_URL + "/images/Logo_Gjeldsregisteret_uAS_Wide_Color.svg"} alt="Gjeldsregisteret AS logo" />
            </div>
            <div id="heading-right" className="col-5">
                <div id="logoutinfo"/>
            </div>
        </div>
    }
}

export default Heading;